import { motion } from "framer-motion";

export default function StepCard({ step, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay: (index || 0) * 0.06, ease: [0.22, 1, 0.36, 1] }}
      className="grid grid-cols-12 gap-6 md:gap-10 py-10 md:py-14 border-b border-white/10"
      data-testid={`step-${step.n}`}
    >
      <div className="col-span-3 md:col-span-2">
        <span className="font-anton text-5xl md:text-7xl text-[#2A5BFF] leading-none">{step.n}</span>
      </div>
      <div className="col-span-9 md:col-span-7">
        <h3 className="font-anton uppercase text-3xl md:text-5xl leading-[0.95] tracking-tight text-white">
          {step.title}
        </h3>
      </div>
      <div className="col-span-12 md:col-span-3 flex md:justify-end">
        <p className="text-white/60 font-light leading-relaxed max-w-xs">{step.body}</p>
      </div>
    </motion.div>
  );
}
